<template>
  <div>
    <b-modal
      id="download-worksheets"
      :ref="ref"
      :title="'Download Student Worksheet'"
      hide-footer
      lazy
    >
      <form @submit.prevent="submit">
        <loading-wrap :loading="loading">
          <div v-if="loading === false">
            <div class="form-group">
              <v-select
                v-model="form.selected"
                :options="questions"
                label="name"
              >
                <template slot="selected-option" slot-scope="option">
                  <span style="text-transform: capitalize">
                    {{ option.category + " - " + option.question }}</span
                  >
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-flex">
                    <span style="text-transform: capitalize">{{
                      option.category + " - " + option.question
                    }}</span>
                  </div>
                </template>
              </v-select>
            </div>
            <hr />
            <div>
              <button
                type="submit"
                class="btn btn-primary btn-block btn-lg"
                :disabled="formLoading"
              >
                <svg-loader />
                <span>Download Selected</span>
              </button>
              <button
                type="button"
                @click="downloadAll()"
                class="btn btn-primary btn-block btn-lg"
                :disabled="formLoading"
              >
                <svg-loader />
                <span>Download All</span>
              </button>
            </div>
          </div>
        </loading-wrap>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      formLoading: false,
      questions: [],
      form: {
        selected: null,
      },
      ref: String(Math.random()).slice(2, 8),
    };
  },
  methods: {
    submit() {
      let filename = `${this.form.selected.category} - ${this.form.selected.question}.pdf`;
      console.log(this.form.selected.filename.path);
      console.log(filename);
      this.axios({
        url: `/worksheet?path=${this.form.selected.filename.path}&filename=${filename}`,
        method: "GET",
        responseType: "blob", // important
      })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          saveAs(blob, filename);
        })
        .catch((error) => {
          this.$root.$emit("popup", {
            type: "error",
            message: `Worksheet file ${filename} not found`,
          });
        });
    },
    downloadAll() {
      let filename = "worksheets.zip";
      this.axios({
        url: "/worksheet/multiple",
        method: "POST",
        data: {
          questions: this.questions,
        },
        responseType: "blob", // important
      })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/zip" });
          saveAs(blob, filename);
        })
        .catch((error) => {
          this.$root.$emit("popup", {
            type: "error",
            message: `Worksheet file ${filename} not found`,
          });
        });
      // let filename = `${q.category} - ${q.question}.pdf`;
      // this.axios({
      //   url: `/worksheet?path=${q.filename.path}&filename=${filename}`,
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const blob = new Blob([response.data], { type: 'application/pdf' });
      //   saveAs(blob, filename);
      // }).catch((error) =>{
      //   this.$root.$emit('popup', {
      //       type: 'error',
      //       message: `Worksheet file ${filename} not found`
      //   })
      // });
      //  });
    },
    initialLoad(id) {
      this.axios
        .get(`${process.env.VUE_APP_API_URL}/api/assessments/${id}`)
        .then((res) => {
          // this.questions = res.data.questions.filter(q=>q.answer <= 3 && q.filename);
          this.questions = res.data.questions;
          this.loading = false;
        });
    },
  },
  created() {
    this.$root.$on("download-worksheets", this.initialLoad);
  },
};
</script>
